var y = (r) => {
  throw TypeError(r);
};
var T = (r, e, t) => e.has(r) || y("Cannot " + t);
var d = (r, e, t) => (T(r, e, "read from private field"), t ? t.call(r) : e.get(r)), S = (r, e, t) => e.has(r) ? y("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(r) : e.set(r, t), p = (r, e, t, s) => (T(r, e, "write to private field"), s ? s.call(r, t) : e.set(r, t), t);
import { c as L, f as E, d as I } from "./chunk-WithApiClient-Da1nY1F5.js";
import { f as A } from "./chunk-firstFocusableElement-B5e7Zq7o.js";
var h, m;
class P {
  constructor(e, t = []) {
    S(this, h);
    S(this, m);
    this.lastFocusedElementSelectorId = null, this.$subSectionsCache = {}, this.skippedParams = [], this.$api = L({
      baseUrl: ""
    }), p(this, h, []), p(this, m, []), (this.host = e).addController(this), this.skippedParams = t;
  }
  /** Fetches the sections from Shopify Rendering API */
  async fetchSections({
    sectionIds: e,
    baseUrl: t = null,
    params: s = {},
    includeExistingParams: c = !0,
    withCache: i = !1
  }) {
    var o;
    if (e.length === 0)
      return {};
    (o = this.abortController) == null || o.abort("Previous request aborted"), this.abortController = new AbortController();
    const n = c ? E(new URLSearchParams(window.location.search)) : {};
    return await this.$api(
      `${t ?? window.location.pathname}`,
      {
        method: "GET",
        signal: this.abortController.signal
      },
      {
        params: {
          ...n,
          ...s,
          sections: e.join(",")
        },
        withCache: i
      }
    );
  }
  /** Adds a callback to be called before the content is replaced */
  addPreProcessCallback(e) {
    d(this, h).push(e);
  }
  /** Adds a callback to be called after the content is replaced */
  addPostProcessCallback(e) {
    d(this, m).push(e);
  }
  hostDisconnected() {
    var e;
    (e = this.abortController) == null || e.abort("Host disconnected");
  }
  _updateAttributes(e, t) {
    Array.from(t.attributes).forEach((s) => {
      s.name !== "cloak" && !this.skippedParams.includes(s.name) && e.getAttribute(s.name) !== s.value && e.setAttribute(s.name, s.value);
    }), Array.from(e.attributes).forEach((s) => {
      s.name !== "cloak" && !this.skippedParams.includes(s.name) && !t.hasAttribute(s.name) && e.removeAttribute(s.name);
    });
  }
  extractSubsectionIds(e) {
    return Array.from(
      e.querySelectorAll("[sub-section-id]")
    ).map((s) => s.getAttribute("sub-section-id")).filter(Boolean);
  }
  selectSubsection(e, t) {
    return e.querySelector(`[sub-section-id="${t}"]`);
  }
  /** Fetches the sections and replaces the content of the renderRoot with the new content
   * @param renderRoot Root element to replace the content with
   * @param forceReplaceAll If true, it will replace all the content of the renderRoot with the new content, skips subsections
   * @param sectionIds List of Section Ids to load from Shopify Rendering API
   * @param baseUrl Base URL to fetch the sections from
   * @param params Query params to send with the request
   * @param includeExistingParams If true, it will include the existing query params in the request, default: true
   * @param withCache If true, it will use the cache to fetch the sections meaning the same sections with same parmas will not be re-fetched, default: false
   *
   * @returns Promise<void>
   */
  async fetchAndReplaceSections({
    renderRoot: e,
    forceReplaceAll: t = !1,
    // If true, it will replace all the content of the renderRoot with the new content, skips subsections
    sectionIds: s,
    baseUrl: c = null,
    params: i = {},
    includeExistingParams: n = !0,
    withCache: a = !1
  }) {
    const o = await this.fetchSections({
      sectionIds: s,
      baseUrl: c,
      params: i,
      includeExistingParams: n,
      withCache: a
    });
    for (const u in o) {
      const l = o[u], f = e.querySelector(
        `[section-id="${u}"]`
      );
      if (!f || !l || typeof l != "string")
        continue;
      const b = this.parseSectionStringForSelector(
        l,
        `[section-id="${u}"]`
      );
      b && await this.replace(
        f,
        b,
        t
      );
    }
  }
  // Fetches the section and replaces the content of the renderRoot with the new content for the section ID provided.
  /** Fetches the section and replaces the content of the renderRoot with the new content for the section ID provided.
   * @param renderRoot Root element to replace the content with
   * @param forceReplaceAll If true, it will replace all the content of the renderRoot with the new content, skips subsections
   * @param sectionId Section ID to fetch from Shopify Rendering API
   * @param baseUrl Base URL to fetch the sections from
   * @param params Query params to send with the request
   * @param includeExistingParams If true, it will include the existing query params in the request, default: true
   * @param withCache If true, it will use the cache to fetch the sections meaning the same sections with same parmas will not be re-fetched, default: false
   * @returns Promise<void>
   **/
  async fetchAndReplaceSectionId({
    renderRoot: e,
    forceReplaceAll: t = !1,
    // If true, it will replace all the content of the renderRoot with the new content, skips subsections
    sectionId: s,
    baseUrl: c = null,
    params: i = {},
    includeExistingParams: n = !0,
    withCache: a = !1
  }) {
    const o = await this.fetchSections({
      sectionIds: [s],
      baseUrl: c,
      params: i,
      includeExistingParams: n,
      withCache: a
    });
    for (const u in o) {
      const l = o[u];
      if (!l || typeof l != "string")
        continue;
      const f = this.parseSectionStringForSelector(
        l,
        `[section-id="${u}"]`
      );
      f && await this.replace(e, f, t);
    }
  }
  _recordLastFocusedElement(e) {
    try {
      const t = document.activeElement;
      t && t.id && (e.contains(t) || t === e) && (this.lastFocusedElementSelectorId = t.id);
    } catch (t) {
      console.error(t);
    }
  }
  _restoreFocusToLastElement(e) {
    try {
      this.lastFocusedElementSelectorId && setTimeout(() => {
        var s;
        const t = document.querySelector(
          `#${this.lastFocusedElementSelectorId}`
        );
        t ? t == null || t.focus() : (s = A(e) || e) == null || s.focus(), this.lastFocusedElementSelectorId = null;
      }, 50);
    } catch (t) {
      console.error(t);
    }
  }
  /** Replaces the content of the renderRoot with the newContent. If the newContent has subsections, it will replace the subsections in the renderRoot with the subsections in the newContent.
   * @param renderRoot Root element to replace the content with
   * @param newContent New content to replace the renderRoot with
   * @param forceReplaceAll If true, it will replace all the content of the renderRoot with the new content, skips subsections
   * @returns Promise<void>
   * */
  async replace(e, t, s = !1) {
    this._recordLastFocusedElement(e), d(this, h).forEach((i) => i(t));
    const c = I();
    document.startViewTransition ? document.startViewTransition(async () => {
      await this._runReplace(e, t, s), c.resolve();
    }) : setTimeout(async () => {
      await this._runReplace(e, t, s), c.resolve();
    }, 0), await c.promise, d(this, m).forEach((i) => i(t)), this._restoreFocusToLastElement(e);
  }
  async _runReplace(e, t, s = !1) {
    const c = s ? [] : this.extractSubsectionIds(t);
    if (c.length > 0)
      for (const i of c) {
        const n = this.selectSubsection(
          t,
          i
        ), a = this.selectSubsection(e, i);
        n && a && (!this._checkSubSectionsCache(i, n.innerHTML) && await this.setInnerHTML(a, n), this._setSubSectionsCache(i, n.innerHTML));
      }
    else
      await this.setInnerHTML(e, t);
  }
  // Sets the subsection content in the cache
  _setSubSectionsCache(e, t) {
    this.$subSectionsCache[e] = t;
  }
  // Checks if the subsection content is in the cache and if it is the same as the new content
  _checkSubSectionsCache(e, t) {
    return this.$subSectionsCache[e] === t ? !0 : (this.$subSectionsCache[e] = t, !1);
  }
  parseSectionStringForSelector(e, t) {
    return new DOMParser().parseFromString(e, "text/html").querySelector(t);
  }
  _render(e, t) {
    this._setInnerHTML(e, t.innerHTML), this._updateAttributes(e, t);
  }
  /** Replaces the content of the renderRoot with the newContent. If the newContent has subsections, it will replace the subsections in the renderRoot with the subsections in the newContent.
   * @param renderRoot Root element to replace the content with
   * @param newContent New content to replace the renderRoot with
   * @returns Promise<void>
   * */
  setInnerHTML(e, t) {
    return new Promise((s) => {
      setTimeout(() => {
        this._render(e, t), s(e);
      }, 0);
    });
  }
  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  _setInnerHTML(e, t) {
    e.innerHTML = t, e.querySelectorAll("script").forEach((s) => {
      var i;
      const c = document.createElement("script");
      Array.from(s.attributes).forEach((n) => {
        c.setAttribute(n.name, n.value);
      }), c.appendChild(
        document.createTextNode(s.innerHTML)
      ), (i = s.parentNode) == null || i.replaceChild(c, s);
    });
  }
}
h = new WeakMap(), m = new WeakMap();
export {
  P as H
};
